import React, { useState } from 'react'
import styled from 'styled-components'

const AccordionContainer = styled.div`
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
`

const AccordionItem = styled.div`
    &:not(:last-child) {
        border-bottom: 1px solid #dee2e6;
    }
`

const AccordionHeader = styled.div`
    padding: 0.75rem 1.25rem;
    background-color: #f8f9fa;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;

    &:hover {
        background-color: #e9ecef;
    }
`

const AccordionContent = styled.div`
    padding: 1.25rem;
    display: ${(props) => (props.isOpen ? 'block' : 'none')};
`

const Accordion = ({ items }) => {
    const [openIndex, setOpenIndex] = useState(null)

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <AccordionContainer>
            {items.map((item, index) => (
                <AccordionItem key={index}>
                    <AccordionHeader onClick={() => toggle(index)}>
                        {item.title}
                        <span>{openIndex === index ? '−' : '+'}</span>
                    </AccordionHeader>
                    <AccordionContent isOpen={openIndex === index}>{item.content}</AccordionContent>
                </AccordionItem>
            ))}
        </AccordionContainer>
    )
}

export default Accordion
